import React from 'react';
import { ISensorFusionUnifiedTaskLookupDto } from '@scale/sensor-fusion-shared';

import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';
import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';

type SfuTaxonomyActionsProps = {
  task: ISensorFusionUnifiedTaskLookupDto;
};

const SfuTaskActions = ({ task }: SfuTaxonomyActionsProps) => {
  const { isRemoAdmin } = useRemoAdminCtx();

  const baseProject = task.project.id;

  const toolUrl = `${isRemoAdmin ? '/remoadmin/tools' : '/corp'}`;

  const remoAdminSfuTaskUrl = `/sensorfusion/remoadmin/task/${task._id}`;
  const scaleSfuTaskUrl = `/sensorfusion/ops-hub/task/${task._id}`;

  return (
    <div className="border-solid border border-neutral-200 px-4 py-4 my-4 w-full overflow-wrap-anywhere">
      <h4 className="font-bold text-lg">Actions</h4>
      <div className="py-1 flex flex-col space-y-2 text-info-700 font-medium cursor-pointer">
        {isRemoAdmin ? (
          <RemotasksExternalLink path={remoAdminSfuTaskUrl}>
            View in SFU Ops Dashboard
          </RemotasksExternalLink>
        ) : (
          <a href={scaleSfuTaskUrl} className="text-info-700">
            View in SFU Ops Dashboard
          </a>
        )}

        {!isRemoAdmin && baseProject && (
          <a href={`${toolUrl}/sfu_redo_recall?projectId=${baseProject}&taskId=${task._id}`}>
            Open in SFU Redo Wizard Tool
          </a>
        )}

        {!isRemoAdmin && baseProject && (
          <a href={`${toolUrl}/sfu_task_tracker/${baseProject}`}>View in SFU Task Tracker</a>
        )}
      </div>
    </div>
  );
};

export default SfuTaskActions;
